// Before adding a new URL to this file, please check
// if it is possible to disable it in config service
export const BANNED_URLS = [
  '/c/customer-service',
];

// Only the legacy compatibility check uses these. Everywhere else the page type
// comes from getCanonicalPageType(), whose vocabulary is the site's own.
export const PAGE_TYPES = {
  HOME: 'HOME',
  CONTENT: 'CONTENT',
  PIP: 'PIP',
  BROWSE: 'BROWSE',
  SEARCH: 'SEARCH',
  BIP: 'BIP',
  UNKNOWN: 'UNKNOWN',
};

// The FAB used to auto-expand on an allowlist of five page types, one of which
// ('browse') no live page ever reports. With the assistant on every nucleus page
// and an open-ended page-type vocabulary, an allowlist silently stops matching
// whenever an experience ships a new value, so this is a denylist instead.
export const FAB_EXPAND_DENYLIST = [
  'cart',
  'checkout',
  'checkout: opc',
];

// Page types where the page is still settling when the assistant mounts, so the
// expand waits longer.
export const EXTENDED_DELAY_PAGE_TYPES = [
  'pip',
  'bip',
  'ppip',
  'plp',
  'category',
  'search results',
];

export const OPEN_TYPES = {
  FAB_OPEN: 'FAB_OPEN',
  FAB_CLOSE: 'FAB_CLOSE',
  DEFAULT_MINIMIZED: 'DEFAULT_MINIMIZED',
  DEFAULT_OPEN: 'DEFAULT_OPEN',
  QUESTION_OPEN: 'QUESTION_OPEN',
  UNKNOWN: 'unknown'
};

export const MAGIC_APRON_CONTAINER_ID = 'DEF_MagicApronLoader';
export const MAGIC_APRON_ASSISTANT_ORIGIN = 'maa';
